import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import { show } from "redux-modal";
import { useDispatch } from "react-redux";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";

import { Icon, IconButton } from "@mui/material";
import BMXUserView from "../../../../../Components/BMXUserView/BMXUserView";
import BMXAutocomplete from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";

const CrmFormStepParticipants = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [workers, setWorkers] = useState([]);

  // NEW COMPONENET
  const [contacts, setContacts] = useState([]);
  const REGISTRY_NAME = "contact";

  const { values, form } = props;

  useEffect(() => {
    // LOADING DICTIONARIS
    const fetchData = async () => {
      const workersFetch = GlobalAuthFetch({ path: "/worker/all" });

      const [workersPayload] = await Promise.all([workersFetch]);

      setWorkers(workersPayload?.payload?.data);
    };
    fetchData();
  }, []);

  return (
    <div
      className="CrmFormStepParticipants"
      style={{ justifyContent: "flex-start" }}
    >
      <BMXSeparator title={t("global:crm.participantsArr")} />
      <Row>
        <Col xs={6}>
          <Field
            component={BMXAutocomplete}
            options={workers}
            data-cy="participantsArr"
            currentValues={values}
            label={t("global:crm.participantsArr")}
            limitTags={1}
            multiple
            name="participantsArr"
            renderOption={(props, option) => (
              <li key={option.uuid} {...props}>
                <BMXUserView color="primary" user={option}></BMXUserView>
              </li>
            )}
            getOptionLabel={(option) =>
              String(
                `${option.lastName} ${option.firstName} ${option.firstName} ${option.lastName}`
              )
            }
            renderTags={(values) => {
              return values.map((option, index) => (
                <BMXUserView
                  comma={values.length - 1 !== index}
                  key={option.uuid}
                  color="primary"
                  user={option}
                ></BMXUserView>
              ));
            }}
          />
        </Col>
        <Col md={6}>
          <div className="summary">
            <span className="pb-2 d-block">
              {t("global:crm.participantsArr")}
            </span>
            <div
              className="area"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              {values?.participantsArr?.map((el) => (
                <BMXUserView
                  className="mt-2"
                  line={"line"}
                  color="primary"
                  user={el}
                ></BMXUserView>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CrmFormStepParticipants;
